export const preloadDesignSystemLocalization = async () => {
  const designSystem = await import("@callcenter/design-system")

  await designSystem.preloadDSLocalization()
}
